import React from 'react';
import { Icon, Button, Card, CardBody } from '@repo/ui';

interface OrganizationCardProps {
  tenantName?: string;
  tenantId?: string;
  onEdit: () => void;
}

export const OrganizationCard: React.FC<OrganizationCardProps> = ({
  tenantName,
  tenantId,
  onEdit,
}) => {
  return (
    <Card
      variant="default"
      className="bg-gradient-to-r from-xtnd-blue/5 to-xtnd-light/50 dark:from-xtnd-blue/10 dark:to-xtnd-dark-800 border-xtnd-blue/20"
    >
      <CardBody className="p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="p-3 bg-xtnd-blue/10 dark:bg-xtnd-blue/20 rounded-xl">
              <Icon name="HiOfficeBuilding" className="h-6 w-6 text-xtnd-blue" />
            </div>
            <div>
              <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1">
                Organization
              </p>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white">
                {tenantName || 'Unknown Organization'}
              </h3>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                Tenant ID:{' '}
                <code className="font-mono text-xtnd-blue">{tenantId || 'N/A'}</code>
              </p>
            </div>
          </div>
          <Button
            onClick={onEdit}
            variant="primary"
            size="md"
            leftIcon={<Icon name="HiPencil" className="h-4 w-4" />}
          >
            Edit
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

